<div class="container">
  <!-- <h2>Historial de operaciones</h2> -->
  <p
    class="disappear-medium-desktop disappear-desktop summary"
    *ngIf="authService?.loggedUser?.activities.length"
  >
    Total comprado este mes :
  </p>
  <p
    class="disappear-medium-desktop disappear-desktop summary"
    *ngIf="authService?.loggedUser?.activities.length"
  >
    {{ monthOperations[0] | number : '0.2-2' }}
    US$ |
    {{ monthOperations[1] | number : '0.2-2' }}
    AR$
  </p>
  <p class="disappear-mobile summary" *ngIf="authService?.loggedUser?.activities.length">
    Total comprado este mes :
    {{ monthOperations[0] | number : '0.2-2' }}
    US$ |
    {{ monthOperations[1] | number : '0.2-2' }}
    AR$
  </p>

  <div class="history-container">
    <div
      *ngIf="!activities.length && !showLoadingHistories"
      class="activities-container no-operations"
    >
      <p>No tenés operaciones</p>
    </div>
    <div class="activities">
      <div class="options" *ngIf="!showLoadingHistories && activities?.length">
        <button
          class="td-btn primary btn-download"
          (click)="downloadHistory()"
          [disabled]="loadingFile"
        >
          Descargar CSV
        </button>
        <!--
          List of types of Activities:
          Type 0 ==> Change / Order
          Type 1 ==> Withdrawal
          Type 2 ==> Deposit
          Type 3 ==> Time Deposit
          Type 4 ==> Staking

          Coin:
          0 ==> U$D
          1 ==> Pesos

          Status:
          0 ==> Cancelled
          1 ==> Pending
          2 ==> Realized
        -->
        <app-paginator
          (paginatorChanges)="handlePaginationChange($event)"
          [data]="authService.historyPagination"
          [disabled]="showLoadingHistories || disablePaginationButtons"
        ></app-paginator>
      </div>
      <div class="table-container">
        <div class="loading-container" *ngIf="showLoadingHistories">
          <div class="loading-item" *ngFor="let i of loadingHistories">
            <div class="text-line"></div>
            <div class="text-line"></div>
          </div>
        </div>
        <div class="table" *ngIf="!showLoadingHistories">
          <app-activity *ngFor="let activity of activities" [activity]="activity"></app-activity>
        </div>
      </div>
    </div>
  </div>
</div>
